// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/notify/v1/notify.proto" (package "c1.api.notify.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.notify.v1.NotifyRequest
 */
export interface NotifyRequest {
    /**
     * @generated from protobuf field: repeated string tokens = 1;
     */
    tokens: string[];
    /**
     * @generated from protobuf field: string offset = 2;
     */
    offset: string;
}
/**
 * @generated from protobuf message c1.api.notify.v1.NotifyResponse
 */
export interface NotifyResponse {
    /**
     * @generated from protobuf field: string offset = 1;
     */
    offset: string;
    /**
     * @generated from protobuf oneof: msg
     */
    msg: {
        oneofKind: "alive";
        /**
         * @generated from protobuf field: c1.api.notify.v1.KeepAlive alive = 100;
         */
        alive: KeepAlive;
    } | {
        oneofKind: "changed";
        /**
         * @generated from protobuf field: string changed = 101;
         */
        changed: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.notify.v1.KeepAlive
 */
export interface KeepAlive {
}
// @generated message type with reflection information, may provide speed optimized methods
class NotifyRequest$Type extends MessageType<NotifyRequest> {
    constructor() {
        super("c1.api.notify.v1.NotifyRequest", [
            { no: 1, name: "tokens", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "1024", unique: true, items: { string: { minBytes: "1", maxBytes: "8192" } } } } } },
            { no: 2, name: "offset", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.notify.v1.NotifyRequest
 */
export const NotifyRequest = new NotifyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotifyResponse$Type extends MessageType<NotifyResponse> {
    constructor() {
        super("c1.api.notify.v1.NotifyResponse", [
            { no: 1, name: "offset", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "alive", kind: "message", oneof: "msg", T: () => KeepAlive },
            { no: 101, name: "changed", kind: "scalar", oneof: "msg", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.notify.v1.NotifyResponse
 */
export const NotifyResponse = new NotifyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeepAlive$Type extends MessageType<KeepAlive> {
    constructor() {
        super("c1.api.notify.v1.KeepAlive", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.notify.v1.KeepAlive
 */
export const KeepAlive = new KeepAlive$Type();
/**
 * @generated ServiceType for protobuf service c1.api.notify.v1.Notify
 */
export const Notify = new ServiceType("c1.api.notify.v1.Notify", [
    { name: "Notify", serverStreaming: true, options: { "authz.method": { role: "VIEWER" } }, I: NotifyRequest, O: NotifyResponse }
]);
